import { mediaQuery, MOBILE_BOTTOM_NAV } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

import { defaultIsScrollableContent } from './ContentLayout.constants';

// Bottom clearance so a page's last control (e.g. a form Save) scrolls clear of the floating mobile
// bottom-nav + its safe-area inset, instead of being occluded by it.
const MOBILE_BOTTOM_EXTRA_GAP = 24;

const MOBILE_BOTTOM_CLEARANCE = `calc(${
  MOBILE_BOTTOM_NAV.GAP + MOBILE_BOTTOM_NAV.HEIGHT + MOBILE_BOTTOM_EXTRA_GAP
}px + env(safe-area-inset-bottom, 0px))`;

export const wrapperStyles = {
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
};

export const getMainContainerStyles = ({
  isScrollableContent = defaultIsScrollableContent,
} = {}) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
  overflowX: 'hidden',
  overflowY: isScrollableContent ? 'auto' : 'hidden',
});

export const getHeaderStyles = ({ disablePaddings, customStyles } = {}) => ({
  zIndex: 2,

  ...getConditionalObject(!disablePaddings, {
    padding: '24px',
  }),

  ...customStyles,
});

export const getContentStyles = ({
  disablePaddings,
  customStyles,
  isScrollable = defaultIsScrollableContent,
} = {}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  flex: 1,
  // Dark: the content area is the dark app canvas (#0E1117) so cards lift above it and there's no
  // lighter gutter butting against page surfaces. Light keeps its subtle gray content background.
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.primary : palette.background.secondary,
  overflowX: 'hidden',
  zIndex: 1,

  ...getConditionalObject(!isScrollable, {
    overflowY: 'hidden',
  }),

  ...getConditionalObject(!disablePaddings, {
    padding: '24px',

    [mediaQuery.mobile]: {
      paddingBottom: MOBILE_BOTTOM_CLEARANCE,
    },
  }),

  ...customStyles,
});
